import { Component } from '@angular/core';
import { LoadingSpinnerService } from './loading-spinner.service';

@Component({
  selector: 'lowy-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent {
  visible = false;
  percentage: number;

  constructor (private loadingSpinnerService: LoadingSpinnerService) {
    this.loadingSpinnerService.spinner$.subscribe(enable => {
      if (enable > 0) {
        this.visible = true;
        if (enable > 1 && enable < 100) {
          this.percentage = enable;
        }
        else {
          this.percentage = null;
        }
      }
      else {
        this.visible = false;
        this.percentage = null;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/loading-spinner/loading-spinner.component.ts